import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  formControl: {
    marginBottom: 16,
    minWidth: (props) => props.width || 120,
    width: (props) => props.width || "100%",
    height: (props) => props.height || "auto",
  },
  label: {
    color: (props) => props.color || "black",
    fontSize: (props) => props.labelFontSize || "1rem",
  },
  // メニューアイテム用のスタイルを追加
  menuItem: {
    fontSize: (props) => props.fontSize || "1rem",
  },
  // Select用のスタイルを追加
  select: {
    fontSize: (props) => props.fontSize || "1rem",
  },
}));

const SelectBoxForNotice = (props) => {
  const {
    label,
    options,
    required,
    select,
    value,
    width,
    height,
    color,
    fontSize,
    labelFontSize,
  } = props;
  const classes = useStyles(props);
  return (
    <FormControl
      className={classes.formControl}
      style={{
        marginBottom: 16,
        minWidth: width,
        width: width,
        height: height,
      }}
    >
      <InputLabel
        className={classes.label}
        style={{ color: color, fontSize: labelFontSize }}
      >
        {label}
      </InputLabel>
      <Select
        required={required}
        value={value}
        onChange={(event) => select(event.target.value)}
        className={classes.select}
      >
        {options.map((option) => (
          <MenuItem
            key={option.id}
            value={option.id}
            className={classes.menuItem}
          >
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectBoxForNotice;
